import _ from 'underscore';
import EventEmitter from 'wolfy87-eventemitter';

export default class ConnectivityService extends EventEmitter {
  constructor(app) {
    super();

    this.videomanager = app.config.globalProperties.$videomanager;
    this.settings = {};
    this.started = false;
    this.promise = null;
    this.initialized = false;

    this.videomanager.on('error', (err) => {
      if (this.initialized) {
        this.emit('error', err);
      }
    });
    this.videomanager.on(
      'audioPreviewPercent',
      _.throttle((e) => {
        if (this.initialized) {
          this.emit('audioPreviewPercent', e);
        }
      }, 50),
    );
  }

  init(settings) {
    if (this.initialized) {
      return;
    }

    this.settings = settings;
    this.initialized = true;
    setTimeout(() => {
      this.emit('ready');
    }, 100);
  }

  destroy({ dispose, forced }) {
    if (!this.initialized && !forced) {
      return;
    }

    this.settings = null;
    this.initialized = false;
    this.emit('destroyed', dispose);
  }

  getSettings() {
    return this.settings;
  }

  updateSettings(type, newValue, mediaOn, targetElementId) {
    if (!this.initialized) {
      return;
    }

    this.settings[type] = newValue;

    if (type === 'audioSource') {
      this.emit('settings:audioSource', newValue, mediaOn);
    }

    if (type === 'videoSource') {
      this.emit('settings:videoSource', newValue, mediaOn, targetElementId);
    }
  }
}
